import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { environment } from 'src/environments/environment';
import { MentorModel } from 'common/models/page-models/mentor/mentor-data-model';
import { MentorListingModel, MentorGridParams } from 'common/models/page-models/mentor/mentor-grid-model';



@Injectable({
    providedIn: 'root'
})
export class MentorGridDataService extends GridDataService<MentorListingModel, MentorModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getMentorMasterData, http, ss);
    }

    createInstance(): MentorListingModel {
        return new MentorListingModel();
    }

    override getDeleteUrl(): string {
        return environment.apiUrl+API_URL.deleteMentorMaster;
    }

    override getGridParams(param): GridPostParams {
        return new MentorGridParams();
    }

    override transformDataModel(apiRes: any, param: string) {
        super.transformDataModel(apiRes, param);
        apiRes[param].forEach((data) => {
            data['isAssigned'] = data.assigned === 1 ? 'Yes' : 'No';
            data['mentorGender'] = data.mentorGender === 'male' ? 'Male' : 'Female';
        })

        return apiRes;
    }

    override getDeletePayload(data) {
        let payload = {
            id : [data.id]
        }
        return payload;
      }

      override getExcelUploadUrl(){
        return environment.apiUrl +API_URL.downloadSampleMentor;
    }
}
